import { ButtonBase } from './ButtonBase';
import styled from 'styled-components';

export const PrimaryButton = styled(ButtonBase)`
    background: var(--accent);
    color: var(--text-accent);
    border-color: color-mix(in oklab, var(--accent) 85%, black);

    &:hover {
        background: color-mix(in oklab, var(--accent) 92%, black);
    }

    &:active {
        background: color-mix(in oklab, var(--accent) 80%, black);
        box-shadow: none;
    }
`
